import React, { useEffect } from 'react'
import Navbar from './Navbar'
import Navbar2 from './Navbar2'
import { useDispatch } from 'react-redux'
import { whislistDataAction } from '../../../Redux/Action/whislistDataAction'
import Whislist from '../User/Whislist'


function MainNavbar() {
    const dispatch = useDispatch()

    const wishlistProducts = JSON.parse(localStorage.getItem("productids")) || [];
    useEffect(() => {
        if (wishlistProducts) {
          dispatch(whislistDataAction(wishlistProducts));
        }
    }, [wishlistProducts])
    
    return (
        <div>
            <Whislist />
            <Navbar />
            <Navbar2/>
        </div>
    )
}

export default MainNavbar
